export const DEFAULT_SUPPORT_EMAIL = "support@erikalust.com";

export const DEFAULT_CHARACTER_INSTANT_MATCH_PROBABILITY_MIN = 0.3;
export const DEFAULT_CHARACTER_INSTANT_MATCH_PROBABILITY_MAX = 0.7;
export const DEFAULT_CHARACTER_PLAY_DELAY_MIN_SECONDS = 6 * 60 * 60;
export const DEFAULT_CHARACTER_PLAY_DELAY_MAX_SECONDS = 16 * 60 * 60;
export const DEFAULT_CHARACTER_REVEAL_STAGGER_MIN_SECONDS = 10;
export const DEFAULT_CHARACTER_REVEAL_STAGGER_MAX_SECONDS = 120;

export interface Constants {
  numberOfCardsPerBatch: number;
  secondsToTriggerLocalNotification: number;
  secondsToReleaseNewCard: number;
  randomSuperlikePaywallProbability?: number;
  numberOfCardsToLoadImages?: number;
  supportEmail: string;
  numberOfDigitsInInvitationCode: number;
  lastCompatibleVersion: string;
  lastCompatibleMainVersionNumber: number;
  lastCompatibleMinorVersionNumber: number;
  lastCompatibleBuildNumber: number;
  characterInstantMatchProbabilityMin?: number;
  characterInstantMatchProbabilityMax?: number;
  characterPlayDelayMinSeconds?: number;
  characterPlayDelayMaxSeconds?: number;
  characterRevealStaggerMinSeconds?: number;
  characterRevealStaggerMaxSeconds?: number;
  /** Gates SELLING only; granted unlocks are always honored. */
  allCardsCoupleUnlockSellingEnabled?: boolean;
  /** Gates SELLING only; granted unlocks are always honored. */
  allCardsCharacterUnlockSellingEnabled?: boolean;
  /** Gates SELLING only; granted unlocks are always honored. */
  allCardsSoloUnlockSellingEnabled?: boolean;
  /** Gates SELLING only; hides the All Cards offer below this many remaining cards. */
  minRemainingCardsForAllCardsUnlock?: number;
}
